import * as React from "react";
import { useLocation } from "react-router-dom";
import { usePermissions, Title, useAuthenticated } from "react-admin";
import { Card, CardContent } from "@mui/material";

const NotFound = () => {
  useAuthenticated();

  const { permissions } = usePermissions();
  const location = useLocation();

  if (!permissions) {
    localStorage.setItem("OSS_RedirectUri", location.pathname);
  } else {
    return (
      <Card>
        <Title title="Not Found" />
        <CardContent>
          <h1>404: Page not found</h1>
        </CardContent>
      </Card>
    );
  }
};

export default NotFound;
